<template>
  <div>
    <Loading :value="loading"></Loading>
    <v-layout row>
      <v-flex xs12>
        <v-card color="" class="mb-5" flat>
          <v-layout wrap>
            <v-flex xs12>
              <v-alert :value="true" outline color="purple" icon="info">
                LISTE DES PROJETS
              </v-alert>

                <v-layout class="mb-3">
                   <v-flex xs3>
                        <v-chip color="orange" style="font-size:19px; width:90%"  text-color="white">
                        <v-avatar  class="orange darken-4"> {{listeProjet.length}} </v-avatar>
                          Projet(S)
                        </v-chip>
                    </v-flex>
                    <v-flex xs3>
                        <div class="col-xl-3">
                            <div class="card l-bg-orange-dark">
                                <div class="card-statistic-3 p-4">
                                    <div class="mb-4">
                                        <h4 class="card-title mb-0">MONTANT TOTAL BUDGET VALIDE </h4>
                                        <h5 id="price">(Somme de tous budgets validés)</h5>
                                    </div>
                                    <div class="row  align-items-center mb-2 d-flex">
                                        <div class="col-8">
                                            <h1 id="price">
                                            {{ new Intl.NumberFormat().format(listeRapport.mntTotalBugValidePro)}} FCFA
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                      <v-flex xs3>
                        <div class="col-xl-3 ml-2">
                            <div class="card l-bg-red-dark">
                                <div class="card-statistic-3 p-4">

                                    <div class="mb-4">
                                        <h4 class="card-title mb-0">MONTANT TOTAL ENGAGÉ </h4>
                                        <h5 id="price">(Somme des montants décaissés)</h5>

                                    </div>
                                    <div class="row  align-items-center mb-2 d-flex">
                                        <div class="col-8">
                                            <h1 id="price">
                                            {{ new Intl.NumberFormat().format(listeRapport.mntTotalDecaissePro)}} FCFA
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs3>
                        <div class="col-xl-3 ml-2">
                            <div class="card l-bg-green-dark">
                                <div class="card-statistic-3 p-4">

                                    <div class="mb-4">
                                        <h4 class="card-title mb-0">MARGE REELLE</h4>
                                        <h5 id="price">(Montant du marché - Total des factures payées)</h5>
                                    </div>
                                    <div class="row  align-items-center mb-2 d-flex">
                                        <div class="col-8">
                                            <h1 id="price">
                                              {{ new Intl.NumberFormat().format(listeRapport.mntmargePro)}} FCFA
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-flex>

                </v-layout>

              <v-card color="" class="mb-5">
                <v-card-text>
                  <v-layout wrap>
                    <!--TABLEAU BUDGET PREVISIONNEL-->
                    <v-flex xs12 class="mt-2">
                      <data-tables :data="listeProjet" style="width: 100%">
                        <!--expand-->
                        <el-table-column type="expand">
                          <template slot-scope="props">
                            <el-row class="elevation-3 pl-4 pr-4 pt-2">
                              <el-col :span="24">
                                <div class="grid-content bg-purple mb-2">
                                  <v-alert
                                    :value="true"
                                    outline
                                    color="primary"
                                    class="mb-4"
                                    icon="info"
                                    >DETAILS DES CHANTIERS
                                  </v-alert>

                                  <div>
                                    <el-table
                                      border
                                      highlight-current-row
                                      :header-row-style="headerRowStyle"
                                      :data="props.row.chantier"
                                      :summary-method="getSummDetailBudget"
                                      show-summary
                                      style="width: 100%"
                                    >
                                      <el-table-column
                                        align="center"
                                        prop="libelle"
                                        label="LIBELLE CHANTIER"
                                      >
                                      </el-table-column>
                                      <el-table-column
                                        align="center"
                                        prop="chefChantier"
                                        label="CHEF CHANTIER"
                                      >
                                        <template slot-scope="scope">
                                          <span v-for="(item, index) in scope.row.chefChantier" :key="index">
                                            <v-chip outline text-color="primary" label> {{ item }}  <v-icon right>person</v-icon> </v-chip>/
                                          </span>                                           
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        prop="budget"
                                        label="BUDGET VALIDE"
                                      >
                                        <template slot-scope="scope">
                                           <v-chip outline text-color="success" label color="success">
                                           {{ new Intl.NumberFormat().format( scope.row.mntTotalChantierValide) }} FCFA <v-icon right>local_atm</v-icon>
                                        </v-chip>
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        prop="ecartBudget"
                                        label="MONTANT ENGAGÉ"
                                        sortable
                                      >
                                        <template slot-scope="scope">
                                           <v-chip outline text-color="red" label color="red">
                                             {{ new Intl.NumberFormat().format( scope.row.mntDepense) }} FCFA <v-icon right>local_atm</v-icon>
                                          </v-chip>
                                        </template>
                                      </el-table-column>

                                      <el-table-column
                                        prop="ecartBudget"
                                        label="ECART BUDGET"
                                        sortable
                                      >
                                        <template slot-scope="prop">
                                          <v-chip
                                            label
                                            outline
                                            color="primary"
                                            >{{ new Intl.NumberFormat().format(prop.row.ecartBudget)}}
                                            FCFA <v-icon right>local_atm</v-icon>
                                            </v-chip
                                          >
                                        </template>
                                      </el-table-column>
                                    <el-table-column label="Evolution" prop="evolution">
                                      <template slot-scope="scope">
                                        <v-progress-circular
                                              :size="85"
                                              :width="15"
                                              :rotate="360"
                                              :value="scope.row.evolution"
                                              color="primary"
                                              >{{ scope.row.evolution }} %</v-progress-circular
                                            >
                                      </template>
                                    </el-table-column>
                                    </el-table>
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                          </template>
                        </el-table-column>
                        <!--expand-->

                        <el-table-column label="Libelle projet" prop="libelle">
                        </el-table-column>
                        <el-table-column
                          label="Chef projet"
                          prop="chef"
                        >
                          <template slot-scope="scope">
                            <v-chip outline text-color="primary" label color="primary">
                              {{ scope.row.chef }}
                              <v-icon right>person</v-icon>
                            </v-chip>
                          </template>
                        </el-table-column>

                        <el-table-column
                          label="Nombre chantier"
                          prop="nbrChantier"
                        >
                          <template slot-scope="scope">
                              <v-chip outline text-color="primary" label color="primary">
                                {{ scope.row.nbrChantier }}
                              </v-chip>
                          </template>
                        </el-table-column>

                        <el-table-column label="Total budget validé" prop="mtDqe">
                          <template slot-scope="scope">
                            <v-chip outline text-color="success" label color="success">
                                {{ new Intl.NumberFormat().format(scope.row.mntBudgetValidePro) }} FCFA <v-icon right>local_atm</v-icon>
                              </v-chip>
                          </template>
                        </el-table-column>

                          <el-table-column label="Montant dépensé" prop="mtDqe">
                          <template slot-scope="scope">
                             <v-chip outline text-color="red" label color="red">
                                {{scope.row.montantTotalDepenseNbr}} FCFA <v-icon right>local_atm</v-icon>
                            </v-chip>
                          </template>
                        </el-table-column>

                        <el-table-column label="Marge réelle" prop="marge">
                          <template slot-scope="scope">
                            <v-chip outline text-color="success" label color="success">
                              {{scope.row.marge }} FCFA <v-icon right>local_atm</v-icon>
                              </v-chip>
                          </template>
                        </el-table-column>

                        <el-table-column label="Evolution" prop="evolution">
                          <template slot-scope="scope">
                            <v-progress-circular
                                  :size="85"
                                  :width="15"
                                  :rotate="360"
                                  :value="scope.row.evolution"
                                  color="primary"
                                  >{{ scope.row.evolutionNbr }} %</v-progress-circular
                                >
                          </template>
                        </el-table-column>

                      </data-tables>
                    </v-flex>
                    <!--TABLEAU BUDGET PREVISIONNEL-->
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<style>
    .card {
        background-color: #fff;
        border-radius: 10px;
        border: none;
        position: relative;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 30px;
        box-shadow: 0 0.46875rem 2.1875rem rgba(90,97,105,0.1), 0 0.9375rem 1.40625rem rgba(90,97,105,0.1), 0 0.25rem 0.53125rem rgba(90,97,105,0.12), 0 0.125rem 0.1875rem rgba(90,97,105,0.1);
    }
   #appercu{
     position: absolute;
      top: 15px;
      left: 40px;
      display: none;
      width: 40px;
      height: 20px;
   }
   .card h4:hover{
     display: block;
    }

    #price{
      border: none;
      position: relative;
      margin: 0 auto;
      text-align: center;
    }

    .l-bg-cherry {
        background: linear-gradient(to right, #493240, #f09) !important;
        color: #fff;
    }

    .l-bg-blue-dark {
        background: linear-gradient(to right, #373b44, #4286f4) !important;
        color: #fff;
    }

    .l-bg-green-dark {
        background: linear-gradient(to right, #0a504a, #38ef7d) !important;
        color: #fff;
    }

    .l-bg-red-dark {
        background: linear-gradient(to right, #c71111, #ffba56) !important;
        color: #fff;
    }
    .l-bg-orange-dark {
        background: linear-gradient(to right, #a86008, #ffba56) !important;
        color: #fff;
    }

    .card .card-statistic-3 .card-icon-large .fas, .card .card-statistic-3 .card-icon-large .far, .card .card-statistic-3 .card-icon-large .fab, .card .card-statistic-3 .card-icon-large .fal {
        font-size: 110px;
    }

    .card .card-statistic-3 .card-icon {
        text-align: center;
        line-height: 50px;
        margin-left: 15px;
        color: #000;
        position: absolute;
        right: -5px;
        top: 20px;
        opacity: 0.1;
    }

    .l-bg-cyan {
        background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
        color: #fff;
    }

    .l-bg-green {
        background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%) !important;
        color: #fff;
    }

    .l-bg-orange {
        background: linear-gradient(to right, #f9900e, #ffba56) !important;
        color: #fff;
    }

    .l-bg-red {
        background: linear-gradient(to right, #c71111, #ffba56) !important;
        color: #fff;
    }

    .l-bg-cyan {
        background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
        color: #fff;
    }
</style>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "DetailBudgetProjet",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogDetail: false,
      listeProjet: [],
      listeRapport : [],
      listeChantier: [],
      listeBudget: [],
      bilanMensuel: [],
      bilanTravaux: [],
      listeDetail: [],
      compte: "0",
      dialogConfirm: false,
      disabledBtnPop: false,
      totalMntPropose: 0,
      totalMntValide: 0
    };
  },

  computed: {},
  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDetail = newValue;
      if (newValue == true) {
        this.listeBudget = this.detailProjet.budgets;
        let _this = this;
        this.totalMntPropose = 0;
        this.totalMntValide = 0;
        this.totalMntMarche = 0;
        this.listeBudget.forEach(item => {
          this.totalMntPropose += item.mntTotalBudgetPropose;
          this.totalMntValide += item.mntTotalBudgetValide;
        });
        this.loadBilan(this.detailProjet.idProj);
      }
    }
  },

  methods: {
    handleTabClick(tab) {
      switch (tab) {
        case "0":
          break;
        case "1":
          break;

        default:
          break;
      }
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSumm(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    closeDialog() {
      this.$emit("close");
    },
    getSummCompte(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSummCompteFinance(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 6) {
          sums[index] = "N/A";
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    handleChange(newValue, oldValue) {
    },
    SubmitValideBudget() {
      this.loading = true;
      let url = this.domaine + "compteExploit/valider/budget_projet";

      let nbData = 10;
      let nbReq = 1;
      let ligne = null;

      let nbRest;
      if (this.listeBudget.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeBudget.length / nbData);
        nbRest = this.listeBudget.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (let i = 0; i < nbReq; i++) {
        let initJ = i * nbData;
        let finJ = (i + 1) * nbData;
        let dataLot = [];
        if (this.listeBudget.length > 0) {
          for (let j = initJ; j < finJ; j++) {
            if (this.listeBudget[j] == undefined) {
              break;
            }
            dataLot.push(this.listeBudget[j]);
          }
        }
        let data = new FormData();
        for (let prop in dataLot) {
          console.lpg("ddjd", dataLot[prop]);
          ligne = dataLot[prop];
          data.append("option[id][]", ligne.id);
          data.append("option[libelle][]", ligne.libelle);
          data.append(
            "option[mntTotalBudgetPropose][]",
            ligne.mntTotalBudgetPropose
          );
          data.append(
            "option[mntTotalBudgetValide][]",
            ligne.mntTotalBudgetValide
          );
          data.append("option[ecartMntTotal][]", ligne.ecartMntTotal);
          data.append("option[idBudget][]", ligne.idBudget);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[mntBudgetPropose][]", ligne.mntBudgetPropose);
          data.append("option[mntBudgetValide][]", ligne.mntBudgetValide);
          data.append("option[ecartBudget][]", ligne.ecartBudget);
          data.append("option[mois][]", ligne.mois);
        }

        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        data.append("idUser", this.user.id);
        data.append("idProjet", this.detailProjet.id);

        this.$http.post(url, data).then(
          resp => {
            this.loading = false;
            succesEnreg = false;
            this.$emit("close");
            this.dialogAjoutBudget = false;
            this.showFourn();
            this.$notify({
              title: "Enregistrement",
              message: "La liste a ete enregistre avec succes",
              type: "success",
              position: "top-right",
              duration: 5000
            });
          },
          error => {
            this.loading = false;
            succesEnreg = false;
            this.dialogAjoutBudget = false;
            this.$message.error("Erreur lors de l'enregistrement des tarifs");
          }
        );
      }
    },
    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
    getSummDetailBudget(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 5) {
          sums[index] = "N/A";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },

    loadBilan(idProjet) {
      this.loading = true;
      let url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.bilanMensuel = response.body.mensuel;
          this.bilanTravaux = response.body.bilanTravaux.travaux;
          this.listeDetail = response.body.detailCompte;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement du bilan"
          );
        }
      );
    },
    imprimeBudgtTravauxPDF(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerPDF_budget_travaux";
      } else {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerEXC_budget_travaux";
      }
      window.open(url);
    },
    imprimeBudgtTravauxPDFSimpl(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerPDF_budget_travauxSimpl";
      } else {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerEXC_budget_travauxSimpl";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifAnnuel(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifAnnuel";
      } else {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifAnnuel";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifAnnuelSimpl(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifAnnuelSimpl";
      } else {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifAnnuelSimpl";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifTravaux(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifTravaux";
      } else {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifTravaux";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifTravauxSimpl(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifTravauxSimpl";
      } else {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifTravauxSimpl";
      }
      window.open(url);
    },

    imprimeBudgtRecapitulatifFinance(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifFinancier";
      } else {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifFinancier";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifFinanceSimpl(type) {
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerPDF_RecapitulatifFinancierSimpl";
      } else {
        url =
          this.domaine +
          "budgetProjet/budget/projet/" +
          this.detailProjet.idProj +
          "/user/" +
          this.user.id +
          "/imprimerEXC_RecapitulatifFinancierSimpl";
      }
      window.open(url);
    },
     loadProjet() {
          let url = this.domaine + "projet/indicateur/projet";

          this.loading = true;
          this.$http.get(url).then(
              response => {
                  this.loading = false;
                  this.listeProjet = response.body.projet;
                  this.listeRapport = response.body.rapport;
              },
              errRep => {
                  this.loading = false;
                  this.$message.error(
                      "Une erreur est survenue lors du chargement de la liste des projets"
                  );
              }
          );
      }
  },
  mounted() {
    this.loadProjet()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/projet/IndicateurProjet.vue